import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const dashboardForRole = (role) => {
  if (role === 'provider') return '/provider/dashboard';
  if (role === 'admin') return '/admin/dashboard';
  return '/client/dashboard';
};

const GuestRoute = ({ children }) => {
  const { user, isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={dashboardForRole(user?.role)} replace />;
  }

  return children;
};

export default GuestRoute;
